import { Box, Link, MenuItem, SvgIconProps, Typography } from "@mui/material";
import type { JSX } from "react";

export type HeaderMenuItemProps = {
  icon?: (props: SvgIconProps) => JSX.Element;
  label: string;
  onClick?: () => void;
  primary?: boolean;
  linkHref?: string;
};

export const HeaderMenuItem = ({
  onClick,
  icon: Icon,
  label,
  linkHref,
  primary = false,
}: HeaderMenuItemProps): JSX.Element => (
  <MenuItem
    onClick={onClick}
    sx={{ p: "2px 0px", my: "4px" }}
    {...(linkHref && linkHref !== "" && { target: "_blank", href: linkHref, component: Link })}
  >
    <Box sx={{ width: 24, mr: 1, display: "inline-flex", justifyContent: "center", alignItems: "center" }}>
      {Icon && <Icon />}
    </Box>
    {linkHref && linkHref !== "" ? (
      <Link
        variant="headerMenuSectionText"
        sx={(theme) => ({ ...(primary && { color: theme.palette.primary.main }) })}
        href={linkHref}
        underline="hover"
        target="_blank"
      >
        {label}
      </Link>
    ) : (
      <Typography
        variant="headerMenuSectionText"
        sx={(theme) => ({ ...(primary && { color: theme.palette.primary.main }) })}
      >
        {label}
      </Typography>
    )}
  </MenuItem>
);
